<template>
  <CashierLayout>
    <template #content>
      <UsageManualPage
        title="Guide pratique caissier"
        subtitle="Un guide simple pour ouvrir la caisse, vendre, gérer le panier, imprimer les tickets, compter l’inventaire et clôturer la journée."
        :items="items"
        :show-table-of-contents="false"
      />
    </template>
  </CashierLayout>
</template>

<script>
import CashierLayout from '@/layouts/CashierLayout.vue';
import UsageManualPage from '@/components/UsageManualPage.vue';
import { cashierManualItems } from '@/support/usageManualContent';

export default {
  name: 'CashierManualView',
  components: {
    CashierLayout,
    UsageManualPage,
  },
  data() {
    return {
      items: cashierManualItems,
    };
  },
};
</script>
